import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { paymentService } from "../services/payment.service";

export const createPayment = createAsyncThunk("createPayment", async (data, { rejectWithValue }) => {
    try {
        return await paymentService.createPayment(data);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const getPaymentList = createAsyncThunk("getPaymentList", async (params, { rejectWithValue }) => {
    try {
        return await paymentService.getPaymentList(params);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const getPayment = createAsyncThunk("getPayment", async (id, { rejectWithValue }) => {
    try {
        return await paymentService.getPayment(id);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const updatePayment = createAsyncThunk("updatePayment", async ({data, id}, { rejectWithValue }) => {
    try {
        return await paymentService.updatePayment(id, data);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

export const deletePayment = createAsyncThunk("deletePayment", async (id, { rejectWithValue }) => {
    try {
        return await paymentService.deletePayment(id);
    } catch (error) {
        if (!error.response) {
            throw error;
        }
        return rejectWithValue(error.response.data);
    }
});

const paymentSlice = createSlice({
    name: "pmo-payment",
    initialState: {
        list: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        detail: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        create: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        update: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
        delete: {
            data: null,
            isLoading: false,
            isError: false,
            message: null,
        },
    },
    reducers: {
        resetStatePayment: (state) => {
            state.list.isError = false;
            state.list.message = null;
            state.detail.isError = false;
            state.detail.message = null;
            state.create.isError = false;
            state.create.message = null;
            state.create.data = null;
            state.update.isError = false;
            state.update.message = null;
            state.update.data = null;
            state.delete.isError = false;
            state.delete.message = null;
            state.delete.data = null;
        },
    },
    extraReducers: (builder) => {
        // get payment list
        builder.addCase(getPaymentList.pending, (state) => {
            state.list.isLoading = true;
        });
        builder.addCase(getPaymentList.fulfilled, (state, action) => {
            state.list.isLoading = false;
            state.list.data = action.payload;
            state.list.isError = false;
        });
        builder.addCase(getPaymentList.rejected, (state, action) => {
            state.list.isLoading = false;
            state.list.isError = true;
            state.list.message = action.payload?.message;
        });

        // get payment detail
        builder.addCase(getPayment.pending, (state) => {
            state.detail.isLoading = true;
        });
        builder.addCase(getPayment.fulfilled, (state, action) => {
            state.detail.isLoading = false;
            state.detail.data = action.payload;
            state.detail.isError = false;
        });
        builder.addCase(getPayment.rejected, (state, action) => {
            state.detail.isLoading = false;
            state.detail.isError = true;
            state.detail.message = action.payload?.message;
        });

        // create payment
        builder.addCase(createPayment.pending, (state) => {
            state.create.isLoading = true;
        });
        builder.addCase(createPayment.fulfilled, (state, action) => {
            state.create.isLoading = false;
            state.create.data = action.payload;
            state.create.isError = false;
        });
        builder.addCase(createPayment.rejected, (state, action) => {
            state.create.isLoading = false;
            state.create.isError = true;
            state.create.message = action.payload?.message;
        });

        // update payment
        builder.addCase(updatePayment.pending, (state) => {
            state.update.isLoading = true;
        });
        builder.addCase(updatePayment.fulfilled, (state, action) => {
            state.update.isLoading = false;
            state.update.data = action.payload;
            state.update.isError = false;
        });
        builder.addCase(updatePayment.rejected, (state, action) => {
            state.update.isLoading = false;
            state.update.isError = true;
            state.update.message = action.payload?.message;
        });

        // delete payment
        builder.addCase(deletePayment.pending, (state) => {
            state.delete.isLoading = true;
        });
        builder.addCase(deletePayment.fulfilled, (state, action) => {
            state.delete.isLoading = false;
            state.delete.data = action.payload;
            state.delete.isError = false;
        });
        builder.addCase(deletePayment.rejected, (state, action) => {
            state.delete.isLoading = false;
            state.delete.isError = true;
            state.delete.message = action.payload?.message;
        });
    },
});

export default paymentSlice.reducer;
export const { resetStatePayment } = paymentSlice.actions;

